import {
  HttpExclude,
  RequestExpose,
  Resource,
  ResourceCollection,
} from 'simpli-web-sdk'
import {ResponsavelGrupoEconomicoCollection} from '@/model/collection/ResponsavelGrupoEconomicoCollection'
import {IResponsavelGrupoEconomicoResourcesHolder} from '@/interfaces/resource/IResponsavelGrupoEconomicoResourcesHolder'

@HttpExclude()
export class ResponsavelGrupoEconomicoFilterCollection extends ResponsavelGrupoEconomicoCollection {
  constructor() {
    super()
  }

  resource?: IResponsavelGrupoEconomicoResourcesHolder
  idList: ResourceCollection<Resource> | null = null

  @RequestExpose() id: number | string | null = null

  set idAsResource(input: Resource | null) {
    this.id = input?.$id || null
  }

  get idAsResource() {
    return this.idList?.getResource(this.id) || null
  }
}
